module.exports = __webpack_public_path__ + "fonts/antonio-regular-unhinted-webfont.af234afa.eot";